var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAfterpayMark = function SvgAfterpayMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.434 4.646 15.319.436c-2.089-1.237-4.7.308-4.7 2.782v.432c0 .39.204.751.533.945l1.344.795c.394.234.886-.058.886-.524V3.79c0-.537.567-.873 1.02-.604l6.163 3.648a.706.706 0 0 1 0 1.207l-6.163 3.648c-.453.27-1.02-.067-1.02-.604v-.572c0-2.474-2.61-4.02-4.7-2.782l-7.116 4.21c-2.088 1.237-2.088 4.33 0 5.566l7.115 4.21c2.089 1.237 4.701-.308 4.701-2.782v-.432c0-.39-.203-.75-.532-.945l-1.344-.797c-.395-.234-.886.058-.886.524v1.075c0 .537-.567.873-1.02.604l-6.163-3.648a.707.707 0 0 1 0-1.209L9.6 10.46c.453-.269 1.02.067 1.02.604v.572c0 2.474 2.61 4.02 4.699 2.783l7.115-4.212c2.088-1.232 2.088-4.325 0-5.56Z",
    fill: "#000"
  })));
};

export default SvgAfterpayMark;